import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyAv7jN8I-Nh7LytioClTzjzJvDQ0psBAOQ",
  authDomain: "appmediatool.firebaseapp.com",
  databaseURL: "https://appmediatool.firebaseio.com",
  projectId: "appmediatool",
  storageBucket: "appmediatool.appspot.com",
  messagingSenderId: "875460466689",
  appId: "1:875460466689:web:0f5a25a1005e3a616e0800"
};
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

